export default "__VITE_ASSET__RG7Ycjl___"